import React from 'react';

const StatisticsCard = ({ title, value, icon, bgColor }) => {
    return (
        <div>
            <div className='flex gap-3'>
                <div className={`flex justify-center items-center w-[45px] h-[45px] rounded-lg ${bgColor || 'bg-primary'}`}>
                    {icon}
                </div>
                <div>
                    <p className="text-title font-bold">{value || 0}</p>
                    <p className='text-base font-semibold text-[#2F2B3D]'>{title}</p>
                </div>
            </div>
        </div>
    )
}

export default StatisticsCard
    